import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
var _IconCheckCircleOutli;
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Avatar, IconCheckCircleOutlined, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Skeleton, Typography } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackContainerStaffSchedulerSiderList(props) {
  var isReschedule = props.isReschedule;
  var intl = useIntl();
  var stepMessages = _extends({
    Patient: intl.formatMessage({
      id: "+0hh6g",
      defaultMessage: [{
        "type": 0,
        "value": "Patient"
      }]
    })
  }, !isReschedule && {
    Form: intl.formatMessage({
      id: "2FcKja",
      defaultMessage: [{
        "type": 0,
        "value": "Pre-scheduling form"
      }]
    })
  }, {
    Schedule: 'Schedule'
  });
  return /*#__PURE__*/_jsxs(List, {
    sx: function sx(theme) {
      return _defineProperty({}, theme.breakpoints.down('md'), {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        '& > *': {
          width: 'fit-content'
        }
      });
    },
    children: [/*#__PURE__*/_jsx(ListItem, {
      sx: function sx(theme) {
        return _defineProperty({
          py: 4
        }, theme.breakpoints.down('md'), {
          width: '30%',
          py: 2
        });
      },
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        children: intl.formatMessage({
          id: "Lv0zJu",
          defaultMessage: [{
            "type": 0,
            "value": "Details"
          }]
        })
      })
    }), Object.entries(stepMessages).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        stepItem = _ref4[0],
        stepItemMessage = _ref4[1];
      return /*#__PURE__*/_jsxs(ListItemButton, {
        disabled: true,
        children: [/*#__PURE__*/_jsx(ListItemAvatar, {
          sx: function sx(theme) {
            return _defineProperty({}, theme.breakpoints.down('md'), {
              minWidth: '0px'
            });
          },
          children: /*#__PURE__*/_jsx(Avatar, {
            sx: {
              bgcolor: 'transparent'
            },
            children: /*#__PURE__*/_jsx(Skeleton, {
              width: "40px",
              height: "40px",
              sx: {
                transform: 'none'
              },
              color: "action"
            })
          })
        }), /*#__PURE__*/_jsx(ListItemText, {
          sx: function sx(theme) {
            return _defineProperty({}, theme.breakpoints.down('md'), {
              display: 'none'
            });
          },
          primary: stepItemMessage
        }), /*#__PURE__*/_jsx(ListItemIcon, {
          sx: {
            justifyContent: 'flex-end',
            opacity: 0
          },
          children: _IconCheckCircleOutli || (_IconCheckCircleOutli = /*#__PURE__*/_jsx(IconCheckCircleOutlined, {}))
        })]
      }, stepItem);
    })]
  });
}